export { version } from '../../root_version.generated.json';
